// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c3ddaee6","453":"57b30f07","732":"949fdbfa","977":"b24e4ae1"}[chunkId] + ".chunk.js";
};